import { render, staticRenderFns } from "./loginAuth.vue?vue&type=template&id=f552e44e&scoped=true&"
import script from "./loginAuth.vue?vue&type=script&lang=js&"
export * from "./loginAuth.vue?vue&type=script&lang=js&"
import style0 from "./loginAuth.vue?vue&type=style&index=0&id=f552e44e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f552e44e",
  null
  
)

export default component.exports